import styled from 'styled-components'

export const Grid = styled.div`
  margin: 8px 20px;
  height: calc(100vh - 240px);
  overflow-y: auto;
`
